const translationProvider = translationNodes => {
  let translations = {};

  translationNodes && translationNodes.forEach(node=>{
    const key = node.key;
    const value = node.value && node.value.value;

    // Check that translation if valid
    if(!key){
      if(!value)
        console.warn(`translator-provider: Got empty translation key and value!`);
      else
        console.warn(`translator-provider: Missing translation key for value '${value}'`);

      return; // Skip invalids
    }

    // Warn about existing keys (This makes too much noice)
    // if(translations[key])
    //   console.warn(`translator-provider: Overwriting translation key ${key}`);

    // Translation is good
    translations[key] = value;
  });

  return key => {
    return translations[key] || key;
  };
};

export default translationProvider;